import Settings from './settings'

export default {
  ...Settings,
  urlHotFolder: 'https://hotfolder.idoccar.com/api/',
  webSocketUrl: 'wss://qa-vgrs-bcn.idoccar.com:8007',
  notificationRefresh: 60000,
  showSignDocumentButton: false,
  acceptFileFormats: 'application/pdf, .jpg, .png, .jpeg, .gif, .docx, .doc, .xls, .xlsx, .ppt, .pptx',
  qaSite: true,
  dealerMaxLength: 7,
  dealerNumberRegex: null,
  clientFieldValidation: 'vgr',
  autoLoadDashboard: false,
  validateLicensePlate: true,
  maxTagCount: 2,
  maxTagTextLength: 10,
  matomoSiteId: '22',
  orderDateLimitHour: '12',
  enableFavoritesAndRecents: true,
  enableTaskFollowUp: true,
  dashboardVersion: 2,
  environmentName: 'qa-vgrs',
  paymentGatewayUrl: 'https://canales.redsys.es/admincanales-web/index.jsp#/login'
}
